// routes/admin/AdminUserDetail.tsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import { useUserProfile } from "../../contexts/UserProfileContext";
import PushOverviewForUser from "./PushOverviewForUser";
import AdminUserFeatures from "./AdminUserFeatures";

import { Link } from "react-router-dom";

type User = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
};

export default function AdminUserDetail() {
  const { userId } = useParams<{ userId: string }>();
  const { profile } = useUserProfile();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !profile || profile.role !== "admin") return;

    const loadUser = async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, first_name, last_name, email")
        .eq("id", userId)
        .single();

      if (error) {
        console.error("❌ Fehler beim Laden des Nutzers:", error);
      } else {
        setUser(data);
      }

      setLoading(false);
    };

    loadUser();
  }, [userId, profile]);

  if (!profile || profile.role !== "admin") {
    return (
      <div className="text-center text-red-400 mt-10">
        Kein Zugriff – nur für Admins 🛑
      </div>
    );
  }

  if (loading) return <p className="p-6 text-slate-400">Lade Nutzerdaten …</p>;

  if (!user)
    return <p className="p-6 text-red-400">❌ Nutzer nicht gefunden.</p>;

  return (
    <div className="max-w-5xl mx-auto mt-10 p-6">
      <h1 className="text-2xl font-bold mb-2 text-sky-400">
        👤 {user.first_name || ""} {user.last_name || ""}
      </h1>
      <p className="text-sm text-slate-400 mb-6">{user.email}</p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* 🧩 Abschnitt: Aufschaltbare Funktionen */}
        <Link
          to={`/admin/users/${user.id}/features`}
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">
            🧩 Aufschaltbare Funktionen
          </h2>
          <p className="text-slate-400">
            Übersicht & Steuerung aktiver Zusatzfunktionen (z. B. AI-Quiz).
          </p>
        </Link>
        {/* 🧩 Abschnitt: Push-Verwaltung */}
        <Link
          to={`/admin/users/${user.id}/push`}
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">
            📬 Push-Token für diesen Nutzer
          </h2>
          <p className="text-slate-400">
            Übersicht der Push-Tokens & Sendeoptionen für diesen Account.
          </p>
        </Link>
      </div>
    </div>
  );
}
